import { useRef, useCallback, useMemo } from 'react';

export const useLongPress = ({
  onClick = () => {},
  onLongPress = () => {},
  ms = 500,
} = {}) => {
  const timerRef = useRef(null);
  const firedRef = useRef(false);
  const eventRef = useRef(null);

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const start = useCallback(
    (e) => {
      // Only consider primary pointer (e.g. first finger / primary mouse button)
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      clear();
      firedRef.current = false;
      eventRef.current = e;

      timerRef.current = setTimeout(() => {
        firedRef.current = true;
        onLongPress && onLongPress(eventRef.current);
        clear();
      }, ms);
    },
    [clear, ms, onLongPress],
  );

  const end = useCallback(
    (e) => {
      if (!timerRef.current) return;
      clear();

      if (!firedRef.current) {
        onClick && onClick(e);
      }
    },
    [clear, onClick],
  );

  const cancel = useCallback(() => {
    clear();
  }, [clear]);

  return useMemo(
    () => ({
      onPointerDown: start,
      onPointerUp: end,
      onPointerLeave: cancel,
      onPointerCancel: cancel,
      onContextMenu: preventContextMenu,
    }),
    [start, end, cancel],
  );
};

function preventContextMenu(e) {
  e.preventDefault();
}
